function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29 27h72v72H29z",
  fill: "none"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85 86.51a3.41 3.41 0 01-2.47-1l-18-17.95a3.5 3.5 0 01-1-2.48 3.5 3.5 0 016-2.47l18 18a3.43 3.43 0 011 2.47 3.48 3.48 0 01-3.5 3.5",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59.23 79.29h11.54v6.38H59.23z",
  fill: "#2c6a9b"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59.23 79.29h11.54v2H59.23z",
  fill: "#1a5a84"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.21 87.24H53.79a1.06 1.06 0 110-2.12h22.42a1.06 1.06 0 010 2.12zm18.01-46.68v37.87a1.19 1.19 0 01-1.2 1.2H37a1.19 1.19 0 01-1.2-1.2V40.56a1.79 1.79 0 011.8-1.8h54.82a1.79 1.79 0 011.8 1.8z",
  fill: "#dceeef"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.22 40.56v37.87a1.19 1.19 0 01-1.2 1.2h-2.61a1.2 1.2 0 001.2-1.2V40.56a1.79 1.79 0 00-1.8-1.8h2.61a1.79 1.79 0 011.8 1.8z",
  fill: "#bcdde2"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68 47.64h26.22V63H68z",
  fill: "#3bc3ff"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.61 47.64h2.61V63h-2.61z",
  fill: "#009af2"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M87.38 56a1.21 1.21 0 01.17 1.06l-1.62 5-.29.91H72.09l1-2.64a.94.94 0 01.12-.22l.53-.82a1.17 1.17 0 00-.32-1.61l-3.12-2.15a1.22 1.22 0 00-.53-.2L68 55.16v-7.52h18.61l-1.32 2.49a1.15 1.15 0 01-1 .62l-5.68.39a1.23 1.23 0 00-.66.26l-2.07 1.66a1.18 1.18 0 00-.34 1.4l.53 1.2a1.17 1.17 0 001.27.68l8.4-1.41a1.16 1.16 0 011.15.46z",
  fill: "#8dffa2"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68 38.76v40.87H37a1.19 1.19 0 01-1.2-1.2V40.56a1.79 1.79 0 011.8-1.8z",
  fill: "#4c94c3"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.22 40.56v2.57H35.78v-2.57a1.79 1.79 0 011.8-1.8h54.84a1.79 1.79 0 011.8 1.8z",
  fill: "#8bc1c6"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.22 73.88v4.55a1.19 1.19 0 01-1.2 1.2H37a1.19 1.19 0 01-1.2-1.2v-4.55z",
  fill: "#3b7ca8"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.22 73.88v4.55a1.19 1.19 0 01-1.2 1.2h-2.61a1.2 1.2 0 001.2-1.2v-4.55z",
  fill: "#2c6a9b"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.43 49.26h-.06a.88.88 0 010-1.76h.06a.88.88 0 110 1.76zm6.05 0h-3.3a.88.88 0 110-1.76h3.3a.88.88 0 010 1.76z",
  fill: "#ff8980"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.43 52.17h-.06a.88.88 0 010-1.76h.06a.88.88 0 010 1.76zm10.12 0h-7.37a.88.88 0 010-1.76h7.37a.88.88 0 110 1.76zm-10.12 2.91h-.06a.89.89 0 010-1.77h.06a.89.89 0 010 1.77zm8.09 0h-5.34a.89.89 0 010-1.77h5.34a.89.89 0 010 1.77zM41.43 58h-.06a.89.89 0 010-1.77h.06a.89.89 0 010 1.77zm16.24 0h-8.55a.89.89 0 010-1.77h8.55a.89.89 0 010 1.77zm-10.98 0h-2.51a.89.89 0 010-1.77h2.51a.89.89 0 110 1.77z",
  fill: "#8dffa2"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.43 60.9h-.06a.89.89 0 010-1.77h.06a.89.89 0 010 1.77zm10.12 0h-7.37a.89.89 0 010-1.77h7.37a.89.89 0 110 1.77zm-10.12 2.9h-.06a.88.88 0 110-1.76h.06a.88.88 0 110 1.76zm10.12 0h-7.37a.88.88 0 110-1.76h7.37a.88.88 0 110 1.76z",
  fill: "#8df4ff"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.43 66.71h-.06a.88.88 0 110-1.76h.06a.88.88 0 010 1.76zm16.89 0h-2.85a.88.88 0 010-1.76h2.85a.88.88 0 110 1.76zm-5.43 0h-8.71a.88.88 0 110-1.76h8.71a.88.88 0 010 1.76zm-11.46 2.91h-.06a.88.88 0 110-1.76h.06a.88.88 0 010 1.76zm10.12 0h-7.37a.88.88 0 010-1.76h7.37a.88.88 0 110 1.76zm2.81 0a.88.88 0 010-1.76.88.88 0 110 1.76zm-4.08-20.36h-.06a.88.88 0 010-1.76h.06a.88.88 0 110 1.76z",
  fill: "#ff8980"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.92 55.08h-.06a.89.89 0 010-1.77h.06a.89.89 0 010 1.77z",
  fill: "#8dffa2"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M56.72 69.62a.88.88 0 010-1.76.88.88 0 010 1.76zm4.63-2.91h-.05a.88.88 0 110-1.76h.05a.88.88 0 110 1.76z",
  fill: "#ff8980"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M54.34 63.85h-.06a.89.89 0 010-1.77h.06a.89.89 0 010 1.77zm0-2.95h-.06a.89.89 0 010-1.77h.06a.89.89 0 010 1.77zm2.38 2.95a.89.89 0 010-1.77.89.89 0 010 1.77zm2.39 0h-.06a.89.89 0 010-1.77h.06a.89.89 0 010 1.77zm2.38 0h-.05a.89.89 0 010-1.77h.05a.89.89 0 010 1.77z",
  fill: "#8df4ff"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.07 66.71H74.49a.88.88 0 010-1.76h16.58a.88.88 0 010 1.76zm-19.07 0h-.84a.88.88 0 010-1.76H72a.88.88 0 110 1.76zm15.73 4.74H71.16a.88.88 0 010-1.76h16.57a.88.88 0 110 1.76zm3.34 0h-.85a.88.88 0 010-1.76h.85a.88.88 0 010 1.76zm0-2.37H71.16a.88.88 0 010-1.76h19.91a.88.88 0 010 1.76z",
  fill: "#4c94c3"
});

var SvgIcCode = function SvgIcCode(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcCode as ReactComponent };